export const getFilenameFromContentDisposition = (contentDisposition: string | null): string | null => {
  if (!contentDisposition) return null;
  const matches = /filename="([^"]+)"/.exec(contentDisposition);
  return matches ? matches[1] : null;
};

export const saveFile = (blob: Blob, filename: string): void => {
  try {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Failed to save file:', error);
  }
};

export const downloadFileFromAssetFolder = (filePath: string, filename: string): void => {
  const link = document.createElement('a');
  link.download = filename;
  link.href = filePath;
  link.click();
};
